import { Switch } from '@/components/ui/Switch'
import { trpc } from '@/lib/trpc'
import { useAppStore } from '@/stores/app.store'

/** Optionale, kundenspezifische Module ein-/ausschalten. Standard: aus. */
export function ModulesTab() {
  const utils = trpc.useUtils()
  const addToast = useAppStore((s) => s.addToast)
  const features = trpc.features.get.useQuery()
  const set = trpc.features.set.useMutation({
    onSuccess: () => {
      utils.features.get.invalidate()
      addToast({ type: 'success', title: 'Gespeichert' })
    },
    onError: (e) => addToast({ type: 'error', title: 'Fehler', description: e.message }),
  })

  return (
    <div className="p-6 max-w-3xl space-y-6">
      <div>
        <h2 className="text-sm font-semibold text-text-primary mb-1">Module</h2>
        <p className="text-xs text-text-tertiary">
          Optionale Funktionen, die nur bei Bedarf eingeschaltet werden. Ausgeschaltete Module sind überall ausgeblendet
          (Menü, Dashboard) und für die Schnittstelle gesperrt; vorhandene Daten bleiben erhalten.
        </p>
      </div>
      <div className="card p-4 flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-text-primary">Ausgaben &amp; Gewinnübersicht</p>
          <p className="text-xs text-text-tertiary mt-1">
            Reiter „Ausgaben" zum manuellen Erfassen (nur netto, ohne USt) und Dashboard-Übersicht mit Ausgaben je Monat/Jahr sowie
            Gewinnentwicklung (Einnahmen netto minus Ausgaben). Sichtbar nur für Inhaber/Administratoren.
          </p>
        </div>
        <Switch
          checked={features.data?.expensesEnabled ?? false}
          disabled={features.isLoading || set.isPending}
          onChange={(v) => set.mutate({ feature: 'expenses', enabled: v })}
        />
      </div>
    </div>
  )
}
